module.exports = __webpack_public_path__ + "static/gallery_west_street_3_thumb-b97ad5aa4510361f90d6e6b2a7cc15e1.jpg";